import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

import {
  getProfileSchedules,
  getScheduleTypeActive,
  SCHEDULE_TYPES,
} from "./schedules.selectors";
import { Schedule } from "./Schedule";
import { Icon } from "../../../../components/icon/Icon";
import { getProfileById } from "../../../../store/profiles/profiles.selectors";
import { getCategories } from "../../../../store/root.selectors";
import { useIntlTranslate } from "../../../../hooks";
import { getCategoriesBlockedByWebFilter } from "../../../../store/categories/categories.selectors";

const ScheduleContainerComponent = ({
  internetOff,
  homework,
  profileId,
  protection,
  categories = [],
  internetOffActive,
  homeworkActive,
}) => {
  const translate = useIntlTranslate();
  const categoriesFetched = !_.isEmpty(categories);
  const blockedByWebFilter = useSelector(
    getCategoriesBlockedByWebFilter(profileId)
  );

  return (
    <Fragment>
      <Schedule
        className={"homework-time"}
        data-id={SCHEDULE_TYPES.HOMEWORK}
        type={SCHEDULE_TYPES.HOMEWORK}
        profile={profileId}
        protection={protection}
        categories={categories}
        isActive={homeworkActive}
        blockedByWebFilter={blockedByWebFilter}
        name={translate("homework_time_schedule")}
        description={translate("homework_time_description")}
        schedules={homework}
        disabled={
          categoriesFetched && categories.length === blockedByWebFilter.length
        }
      />
      <section>
        <h2 className="internet-off__header">
          <Icon icon="fa-regular fa-calendar-alt" />
          <span>{translate("internet-off")}</span>
        </h2>
        <Schedule
          className={"internet-off"}
          data-id={SCHEDULE_TYPES.INTERNET_OFF}
          type={SCHEDULE_TYPES.INTERNET_OFF}
          profile={profileId}
          name={translate("internet_off_schedule")}
          isActive={internetOffActive}
          description={translate("internet_off_description")}
          schedules={internetOff}
        />
      </section>
    </Fragment>
  );
};

export const ScheduleContainer = ({ className, profileId }) => {
  const schedules = useSelector((state) => state.schedules);
  const categories = useSelector(getCategories);
  const profile = useSelector(getProfileById(profileId));
  const protection = profile && profile.protection;

  const internetOff = getProfileSchedules(
    schedules,
    profileId,
    SCHEDULE_TYPES.INTERNET_OFF
  );
  const homework = getProfileSchedules(
    schedules,
    profileId,
    SCHEDULE_TYPES.HOMEWORK
  );
  const internetOffActive = getScheduleTypeActive(
    schedules,
    profileId,
    SCHEDULE_TYPES.INTERNET_OFF
  );
  const homeworkActive = getScheduleTypeActive(
    schedules,
    profileId,
    SCHEDULE_TYPES.HOMEWORK
  );

  return (
    <ScheduleContainerComponent
      internetOff={internetOff}
      homework={homework}
      profileId={profileId}
      protection={protection}
      categories={categories}
      internetOffActive={internetOffActive}
      homeworkActive={homeworkActive}
      className={className}
    />
  );
};
